export default __webpack_public_path__ + "static/media/unknown-icon.a9c50fec.svg";